module.exports = __webpack_public_path__ + "static/weddingBoothMock-4584863adf55634d7ff6822096f2b892.png";